"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupIcon = exports.UserMultiIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** UserMultiIcon */
var UserMultiIcon = function UserMultiIcon(props) {
  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), _react.default.createElement("title", null, "group"), _react.default.createElement("path", {
    d: "M11.654 10.226v3.214h-.875v-3.214c0-.725-.588-1.312-1.313-1.312h-.924c-.725 0-1.313.587-1.313 1.312v3.214h-.875v-3.214c0-.725-.587-1.312-1.312-1.312h-.853c-.725 0-1.313.587-1.313 1.312v3.214h-.875v-3.214c0-1.208.98-2.187 2.188-2.187h.853c.715 0 1.35.343 1.75.874a2.184 2.184 0 0 1 1.75-.874h.924c.716 0 1.351.343 1.75.874a2.184 2.184 0 0 1 1.75-.874h.88c1.207 0 2.187.98 2.187 2.187v3.214h-.875v-3.214c0-.725-.588-1.312-1.313-1.312h-.879c-.725 0-1.312.587-1.312 1.312zM4.41 7.01a1.866 1.866 0 1 1 0-3.732 1.866 1.866 0 0 1 0 3.732zm0-.875a.991.991 0 1 0 0-1.982.991.991 0 0 0 0 1.982zm4.5.875a1.866 1.866 0 1 1 0-3.732 1.866 1.866 0 0 1 0 3.732zm0-.875a.991.991 0 1 0 0-1.982.991.991 0 0 0 0 1.982zm4.5.875a1.866 1.866 0 1 1 0-3.732 1.866 1.866 0 0 1 0 3.732zm0-.875a.991.991 0 1 0 0-1.982.991.991 0 0 0 0 1.982z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.UserMultiIcon = UserMultiIcon;
UserMultiIcon.displayName = "UserMultiIcon";
// TODO: remove this alias once clients have been updated

/** GroupIcon */
var GroupIcon = UserMultiIcon;
exports.GroupIcon = GroupIcon;
//# sourceMappingURL=UserMultiIcon.js.map